<template>
  <!-- content_wrapper_start -->
  <div>
    <!-- container_content_wrapper_start -->
    <b-container fluid style="height: calc(100vh - 181px);">
      <!-- page_title_start -->
      <h5 class="d-block">
        {{ $lang.PCI.Spreadsheet.Title }}
      </h5>
      <!-- page_title_end -->

      <div >
          <b-button @click="onShowAnnex" variant="light" v-if="hasRole(roles.RW_OPER_PCI_DOCUMENTATION) || hasRole(roles.R_OPER_PCI_DOCUMENTATION)" b-v-tooltip.hover :title="$lang.PCI.Spreadsheet.ContractAnnex"><i class="fas fa-paperclip"></i></b-button>
          <b-button @click="onShowResume" variant="light" b-v-tooltip.hover :title="$lang.PCI.Items.LabelResume"><i class="fas fa-layer-group"></i></b-button>
      </div>

      <!-- pcis_selection_wrapper_start -->
      <b-row class="min-vh-30" style="height: calc(100vh - 270px);">
        <!-- contracts_start -->
        <div class="d-flex flex-column w-100 py-3">
          <!-- contracts_grid_wrapper_start -->
          <!-- <div v-if="contracts">
          </div> -->
          <ag-grid-vue
            class="flex-grow-1 ag-theme-alpine"
            :getLocaleText="localeTextFunc"
            :defaultColDef="defaultColumnDef"
            :gridOptions="gridOptions"
            :columnTypes="columnTypes"
            :columnDefs="columnDefs"
            :rowData="contracts"
            :excelStyles="excelStyles"
            :suppressCopyRowsToClipboard="true"
            rowSelection="multiple"
            @rowDoubleClicked="selectContract"
            @filterChanged="onFilterChanged"
            :getRowId="params => params.data.pciId"
            :suppressContextMenu="true"
            :rowHeight="25"
            style="border-radius: 6px;"
          >
          </ag-grid-vue>
          <!-- contracts_grid_wrapper_end -->
          <div class="d-flex w-100 align-items-center mt-1">
            <i class="fas fa-filter mr-1"></i>
            <v-select ref="filterHistory"
                    id="filter-history"
                    :options="filterList"
                    v-model="filterSelected"
                    class="w-100"
                    @input="onChangeFilter"
                    size="sm"
                    :searchable="false"
                    appendToBody
                    :calculatePosition="withPopper"
                    :placeholder="$lang.Common.Buttons.History + '...'">
              <template #no-options>
                <span>...</span>
              </template>
              <template #option="{ label }">
                <div style="font-size: 0.5rem; color: #000;">
                  {{ label }}
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <!-- contracts_end -->
      </b-row>
      <!-- pcis_selection_wrapper_end -->

      <!-- actions_row_start -->
      <b-row
          cols="12"
      >
        <!-- select_button_start -->
        <b-col class="d-flex justify-content-start">
          <b-button
            @click="selectContract"
            variant="third"
            size="sm"
          >
            {{$lang.Common.Select}}
          </b-button>
        </b-col>
        <!-- select_button_end -->
      </b-row>
      <!-- actions_row_end -->
    </b-container>

    <!-- container_content_wrapper_end -->
    <annex mode="multi-contract" ref="annex" v-if="(hasRole(roles.RW_OPER_PCI_DOCUMENTATION)|| hasRole(roles.R_OPER_PCI_DOCUMENTATION)) && showAnnex" @close="showAnnex = false" />
    <resume ref="resume" v-if="hasRole(roles.RW_OPER_PCI_REPORT) && showResume" @close="showResume = false" />
  </div>
  <!-- content_wrapper_end -->
</template>

<script>
import Spreadsheet from './spreadsheet'
export default Spreadsheet
</script>

<style>
.spreadsheet-toggleClass {
  font-size: 0.5rem;
}
</style>
<style scoped>
  * >>> div.ag-virtual-list-item {
    width: fit-content;
  }
  * >>> .ag-tabs {
    width: 32em;
  }
  #filter-history.v-select {
  --vs-dropdown-option--active-color: #000;
  --vs-line-height: 0;
  --vs-font-size: 0.65rem;
  font-size: var(--vs-font-size);
  }
  #filter-history.v-select >>> .vs__selected-options > input {
    max-width: 1px;
  }
  #filter-history.v-select >>> .vs__selected,
  #filter-history.v-select >>> .vs_search {
    margin: 0;
    padding: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: calc(100vw - 440px);
  }
  * >>> .vs__dropdown-toggle {
    padding: 0;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/spreadsheet/spreadsheet.vue